import { FC } from "react";
import light500 from "assets/svg/no-found-interview.svg";
const InvelidLink: FC<{ linkValidationError: string }> = ({
  linkValidationError,
}) => {
  return (
    <div
      className="mx-auto d-flex align-items-center flex-column"
      style={{ margin: "auto" }}
    >
      <div className="mb-11">
        <img
          src={light500}
          className="mw-100 mh-300px theme-light-show"
          alt=""
        />
        <img
          src={light500}
          className="mw-100 mh-300px theme-dark-show"
          alt=""
        />
      </div>
      <h1 className="fw-bolder fs-2qx text-gray-900 mb-4">Link Not Found! </h1>

      <div className="fw-semibold fs-4 text-gray-600 mb-7">
        This link is no longer valid. Please verify the URL or go to the Login
        Page
      </div>
      <div className="mb-0">
        <button
          className="btn btn-sm btn-primary"
          onClick={() => {
            window.location.href = "/login";
          }}
        >
          Go to Login
        </button>
      </div>
    </div>
  );
};

export { InvelidLink };
